
export default {
  name: 'PagesAboutExtentionsCalculator',
  props: {
    selectedServices: {
      type: Array,
      default: () => [],
    },
    source: {
      type: Object,
      default: () => {
        return {
          position:
            'Клик по кнопке "Подключить" калькулятор стоимости расширений',
          chapter: 'Страница "О нас | Расширения"',
        }
      },
    },
  },
  data() {
    return {
      activePeriod: null,
      checkedGifs: [],
      maxGifts: 1,
    }
  },
  computed: {
    lead() {
      const serv = this.services.reduce(
        (acc, service) =>
          acc +
          ' - ' +
          service.title +
          ` ( ${
            service.price && service.price !== 0 ? service.price : 0
          } ₽/мес )` +
          '\n',
        ''
      )
      const price = `Период: ${
        this.activePeriod ? this.activePeriod.title : ''
      }\nСкидка за предоплату ${this.discont}%\nСтоимость: ${
        this.monthCost
      } ₽/мес\nСтоимость co скидкой: ${
        this.monthDiscontCost
      } ₽/мес\nОбщая выгода за предоплату: ${
        this.fullBenefit
      } ₽\nИтого за период: ${this.fullDiscountCost} ₽\n`
      const gift = `Выбранный подарок при оплате до ${
        this.endDayForConnect
      }:\n - <b>${
        this.checkedGifs?.length
          ? this.serviceById(this.checkedGifs[0]).title
          : ''
      }</b> (<i>${
        this.checkedGifs?.length
          ? this.serviceById(this.checkedGifs[0]).description
          : ''
      }</i>)`
      const leadBody =
        'Выбранные сервисы:\n' + serv + '\n' + price + '\n' + gift
      return {
        title: 'Подключение расширений для профиля',
        description: 'Наш специалист свяжется с вами',
        data: {
          title: 'Запросил подключить расширения',
          to: 'forbusiness',
          type: 'CALL',
          level: 'BUSINESS',
          body: leadBody,
          source: {
            ...this.source,
            source: this.$route.path,
          },
        },
      }
    },
    gifts() {
      const allGifts = this.$store.getters['settings/getGifts']
      const gifts = allGifts.filter(
        (gift) => gift.inConnection && !gift.inTariff
      )
      return gifts
    },
    endDayForConnect() {
      const endDate = this.$dayjs().add(3, 'day')
      return this.$dayjs(endDate).format('D MMMM')
    },
    services() {
      const services = this.$store.getters['settings/getServices']
      return services.filter((service) =>
        this.selectedServices?.includes(service._id)
      )
    },
    discont() {
      return this.activePeriod?.discont ? this.activePeriod.discont : 0
    },
    monthCost() {
      return this.services.reduce((acc, service) => acc + service.price, 0)
    },
    monthDiscontCost() {
      const discountSumm = (this.monthCost * this.discont) / 100
      return this.monthCost - discountSumm
    },
    fullCost() {
      const period = this.activePeriod?.period ? this.activePeriod.period : 0
      return this.monthCost * period
    },
    fullOldCost() {
      return this.services.reduce(
        (acc, service) => acc + service.price + service.oldPrice,
        0
      )
    },
    fullDiscountCost() {
      const period = this.activePeriod?.period ? this.activePeriod.period : 0
      return this.monthDiscontCost * period
    },
    fullBenefit() {
      return this.fullCost - this.fullDiscountCost
    },
    periods() {
      const periods = this.$store.getters['settings/getPeriods']
      return periods
    },
  },
  mounted() {
    this.setDefaultActivePeriod()
  },
  methods: {
    setDefaultActivePeriod() {
      if (this.periods?.length) {
        this.activePeriod = this.periods.find((period) => period.default)
      }
    },
    sendLid() {
      setTimeout(() => {
        this.isShowFullViewButton = false
      }, 100)
      this.$refs.orderForm.open()
    },
    serviceById(id) {
      const gift = this.gifts.find((gift) => gift._id === id)
      return gift
    },
  },
}
